import React from 'react';
import styles from './Breadcrumb.module.scss'
import Link from 'next/link';
import { URL_BASE } from "../settings/global";
import { useRouter } from "next/router";
import { JSONLD } from "../helpers/seo/seo";

export default function Breadcrumb({className, children, inverse}) {

    const getSeoBreadcrumbs = (children) => {
        // this data is required for google to understand file structure
        // see details : https://developers.google.com/search/docs/appearance/structured-data/breadcrumb
        const router = useRouter();
        let breadcrumbsData = [];

        React.Children.map(children, (child, index) => {

            const childProps = child.props;
            const position = index + 1;
            const name = childProps?.name;
            const item = `${URL_BASE}${index !== 0 ? childProps?.link ? childProps.link : router.asPath : ''}`;

            breadcrumbsData.push({
                "@type": "ListItem",
                "position": position,
                "name": name,
                "item": item
            })
        })

        return <JSONLD
            data={{"@type": "BreadcrumbList", "itemListElement": breadcrumbsData}}
            tagKey='breadcrumb-jsonld'
        />

    }

    const renderChildren = (children) => {
        return (
            React.Children.map(children, (child, index) => {
                switch (true) {
                    case index !== children.length - 1:
                        return React.cloneElement(child, {inverse})
                    case index === children.length - 1:
                        return React.cloneElement(child, {
                            active: 'active' in child.props ? child.props.active : true,
                            inverse
                        })
                    default:
                        return child
                }
            })
        )
    };

    return (
        <React.Fragment>
            {getSeoBreadcrumbs(children)}
            <div className={`${styles['breadcrumb']}${className ? ' ' + className : ''}`}>
                <div className={styles['breadcrumb__container']}>
                    {renderChildren(children)}
                </div>
            </div>
        </React.Fragment>
    )
}

export function BreadcrumbLayer({link, name, active, internal, onClick, inverse}) {

    const isInverse = !!inverse ? ` ${styles['layer--inverse']}` : '';

    return (
        <div className={`${styles['layer']}${isInverse}`}>
            <div className={styles['layer__item']}>
                <p className={styles['layer__item__slash']}>/</p>
                {
                    !active
                        ?
                        !!internal
                            ? <Link href={link} className={styles['layer__item__link']}>
                                {name}
                            </Link>
                            : <a
                                href={onClick ? undefined : link}
                                className={styles['layer__item__link']}
                                onClick={onClick}
                            >
                                {name}
                            </a>
                        :
                        <p className={styles['layer__item__text']}>{name}</p>
                }
            </div>
        </div>
    );
}